import Vue from 'vue'

import VueRouter from 'vue-router'

import { getToken, getAdmin } from '@/utils/auth'
import AdminLayout from '@/layout/AdminLayout.vue'

Vue.use(VueRouter)



const routes = [

  {

    path: '/login',

    name: 'Login',

    component: () => import('@/views/login/index.vue'),

    meta: { public: true, title: '登录' }

  },

  {

    path: '/',

    component: AdminLayout,

    redirect: '/dashboard',

    children: [

      {

        path: 'dashboard',

        name: 'Dashboard',

        component: () => import('@/views/dashboard/index.vue'),

        meta: { title: '数据概览', icon: 'el-icon-data-analysis' }

      },

      {

        path: 'users',

        name: 'Users',

        component: () => import('@/views/user/index.vue'),

        meta: { title: '用户管理', icon: 'el-icon-user' }

      },

      {

        path: 'commissions',

        name: 'Commissions',

        component: () => import('@/views/commission/index.vue'),

        meta: { title: '佣金审核', icon: 'el-icon-coin' }

      },

      {

        path: 'agent-applications',

        name: 'AgentApplications',

        component: () => import('@/views/agent-application/index.vue'),

        meta: { title: '代理审核', icon: 'el-icon-s-check' }

      },

      {

        path: 'withdrawals',

        name: 'Withdrawals',

        component: () => import('@/views/withdraw/index.vue'),

        meta: { title: '提现审核', icon: 'el-icon-money' }

      },

      {

        path: 'agent-settings',

        name: 'AgentSettings',

        component: () => import('@/views/agent-settings/index.vue'),

        meta: { title: '代理文案', icon: 'el-icon-edit' }

      },

      {

        path: 'plans',

        name: 'Plans',

        component: () => import('@/views/plan/index.vue'),

        meta: { title: '方案管理', icon: 'el-icon-document' }

      },

      {

        path: 'plan-algorithm',

        name: 'PlanAlgorithm',

        component: () => import('@/views/plan-algorithm/index.vue'),

        meta: { title: '方案算法', icon: 'el-icon-cpu' }

      },

      {

        path: 'orders',

        name: 'Orders',

        component: () => import('@/views/order/index.vue'),

        meta: { title: '订单管理', icon: 'el-icon-s-order' }

      },

      {

        path: 'recharge',

        name: 'Recharge',

        component: () => import('@/views/recharge/index.vue'),

        meta: { title: '充值管理', icon: 'el-icon-wallet' }

      },

      {

        path: 'banners',

        name: 'Banners',

        component: () => import('@/views/banner/index.vue'),

        meta: { title: '轮播管理', icon: 'el-icon-picture-outline' }

      },

      {

        path: 'announcements',

        name: 'Announcements',

        component: () => import('@/views/announcement/index.vue'),

        meta: { title: '公告管理', icon: 'el-icon-bell' }

      },

      {

        path: 'messages',

        name: 'Messages',

        component: () => import('@/views/message/index.vue'),

        meta: { title: '站内信', icon: 'el-icon-message' }

      },

      {

        path: 'contact',

        name: 'Contact',

        component: () => import('@/views/contact/index.vue'),

        meta: { title: '联系我们', icon: 'el-icon-phone-outline' }

      },

      {

        path: 'trading-settings',

        name: 'TradingSettings',

        component: () => import('@/views/trading-settings/index.vue'),

        meta: { title: '交易设置', icon: 'el-icon-time' }

      },

      {

        path: 'registration-settings',

        name: 'RegistrationSettings',

        component: () => import('@/views/registration-settings/index.vue'),

        meta: { title: '注册设置', icon: 'el-icon-edit-outline' }

      },

      {

        path: 'app-download',

        name: 'AppDownloadSettings',

        component: () => import('@/views/app-download/index.vue'),

        meta: { title: '下载APP地址', icon: 'el-icon-download' }

      },

      {

        path: 'security-questions',

        name: 'SecurityQuestions',

        component: () => import('@/views/security-questions/index.vue'),

        meta: { title: '找回密码', icon: 'el-icon-key' }

      },

      {

        path: 'app-versions',

        name: 'AppVersions',

        component: () => import('@/views/app-version/index.vue'),

        meta: { title: 'APP 版本', icon: 'el-icon-mobile-phone' }

      },

      {

        path: 'admin-accounts',

        name: 'AdminAccounts',

        component: () => import('@/views/admin-account/index.vue'),

        meta: { title: '管理员账号', icon: 'el-icon-s-custom', superOnly: true }

      }

    ]

  },

  { path: '*', redirect: '/dashboard' }

]



const router = new VueRouter({

  mode: 'hash',

  routes

})



router.beforeEach((to, from, next) => {

  document.title = to.meta.title ? `${to.meta.title} - 暗潮管理后台` : '暗潮管理后台'

  if (to.meta.public) {

    next()

    return

  }

  if (!getToken()) {

    next({ path: '/login', query: { redirect: to.fullPath } })

    return

  }

  if (to.meta.superOnly) {

    const admin = getAdmin()

    if (!admin || admin.role !== 'super') {

      next('/dashboard')

      return

    }

  }

  next()

})



export default router

